{
  "title": "Maelstrom",
  "source": "Xanathar's Guide to Everything",
  "levelAndSchool": "5th-level evocation",
  "level": 5,
  "castingTime": "1 action",
  "range": "120 feet",
  "components": "V, S, M (paper or leaf in the shape of a funnel)",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "A mass of 5-foot-deep water appears and swirls in a 30-foot radius centered on a point you can see within range. The point must be on ground or in a body of water. Until the spell ends, that area is difficult terrain, and any creature that starts its turn there must succeed on a Strength saving throw or take 6d6 bludgeoning damage and be pulled 10 feet toward the center."
  ],
  "spellLists": ["druid"]
}
